
import './style.scss';
import { Box, Typography } from '@mui/material';


interface IChartCardProps {
    title: string;
    chart: JSX.Element;
    height?: number;
    className?: string;
}


const ChartCard: React.FC<IChartCardProps> = ({
    title,
    chart,
    height = 320,
    className = ''
}) => {
    return (
        <Box className={`chartcard-default ${className}`} >
            <Typography className='chartcard-title'>{title}</Typography>
            
            <Box className='chartcard-box' height={height}>
                {chart}
            </Box>
        </Box>
    );
}

export default ChartCard;